import { render, staticRenderFns } from "./former.vue?vue&type=template&id=030e2efb&"
import script from "./former.vue?vue&type=script&lang=js&"
export * from "./former.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports